export enum TagType {
    DISCOUNT = 'discount',
    PROMO = 'promotional',
    THEMED = 'themed'
}

export default TagType;
